/* assets/lg-video-lazy.js
   Reliable iOS/Safari-friendly lazy video loader with autoplay-attempt + tap-to-play fallback.
*/

(function () {
  function isVideoReady(v) {
    return v && v.readyState >= 2; // HAVE_CURRENT_DATA
  }

  function setVideoSource(video) {
    if (!video) return;
    if (video.dataset.srcSet === "1") return;

    var src = video.getAttribute("data-video-src") || video.dataset.videoSrc;
    if (!src) return;

    // Prefer <source> for broader compatibility, but direct src also works
    // We'll use direct src to keep it simple.
    video.src = src;
    video.dataset.srcSet = "1";
    video.load();
  }

  function showOverlay(wrapper, show) {
    var overlay = wrapper.querySelector("[data-lg-video-overlay]");
    if (!overlay) return;
    if (show) overlay.removeAttribute("hidden");
    else overlay.setAttribute("hidden", "hidden");
  }

  function attemptPlay(wrapper, video) {
    if (!video) return;

    // Ensure source exists
    setVideoSource(video);

    // Try autoplay (will fail on iOS in Low Power Mode, or if policy blocks)
    var playPromise;
    try {
      playPromise = video.play();
    } catch (e) {
      // Synchronous failure: show overlay
      showOverlay(wrapper, true);
      return;
    }

    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          // Playback started
          showOverlay(wrapper, false);
        })
        .catch(function () {
          // Autoplay blocked or failed
          showOverlay(wrapper, true);
        });
    } else {
      // Older behavior: if it didn't start, keep overlay
      // Give it a beat and check
      setTimeout(function () {
        if (video.paused) showOverlay(wrapper, true);
        else showOverlay(wrapper, false);
      }, 250);
    }
  }

  function bindTapToPlay(wrapper, video) {
    var overlay = wrapper.querySelector("[data-lg-video-overlay]");
    if (!overlay) return;

    overlay.addEventListener("click", function () {
      // User gesture should allow play even when autoplay is blocked
      setVideoSource(video);

      // If autoplay was blocked because of policy, user tap usually fixes it.
      // If Low Power Mode is on, this is still the best you can do: let user initiate.
      var p;
      try {
        p = video.play();
      } catch (e) {
        // As a last resort, expose controls so user can start manually.
        video.setAttribute("controls", "controls");
        showOverlay(wrapper, false);
        return;
      }

      if (p && typeof p.then === "function") {
        p.then(function () {
          showOverlay(wrapper, false);
        }).catch(function () {
          // If even user gesture fails (rare), show controls
          video.setAttribute("controls", "controls");
          showOverlay(wrapper, false);
        });
      } else {
        // Non-promise play(): hide overlay if video appears to play
        setTimeout(function () {
          if (!video.paused) showOverlay(wrapper, false);
          else {
            video.setAttribute("controls", "controls");
            showOverlay(wrapper, false);
          }
        }, 250);
      }
    });
  }

  function initOne(wrapper) {
    if (!wrapper || wrapper.dataset.lgInit === "1") return;
    wrapper.dataset.lgInit = "1";

    var video = wrapper.querySelector("video");
    if (!video) return;

    // Default: show overlay until we successfully start playback
    showOverlay(wrapper, true);

    // If video errors, keep overlay
    video.addEventListener("error", function () {
      showOverlay(wrapper, true);
    });

    bindTapToPlay(wrapper, video);

    // Lazy-start when near viewport
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              attemptPlay(wrapper, video);
            }
          });
        },
        { root: null, rootMargin: "200px 0px", threshold: 0.01 }
      );

      io.observe(wrapper);
    } else {
      // Fallback: just try after load
      window.addEventListener("load", function () {
        attemptPlay(wrapper, video);
      });
    }

    // If already loaded and ready, try immediately
    if (isVideoReady(video)) {
      attemptPlay(wrapper, video);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll("[data-lg-video]");
    for (var i = 0; i < nodes.length; i++) {
      initOne(nodes[i]);
    }
  }

  // Init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // If your slideshow re-renders slides dynamically, re-init on common events
  // (Safe: initOne guards against double init)
  window.addEventListener("shopify:section:load", initAll);
  window.addEventListener("shopify:section:select", initAll);
})();
